export default __webpack_public_path__ + "static/media/see-icon.d42e2dff.svg";